<template>
    <div class="about">
      <TransitionGroup>
        <div class="card mx-auto my-5 shadow" style="min-width: 18rem; max-width: fit-content;overflow: auto;" v-if="showModal">
          <div class="card-body">
            <h5 class="card-title">
               Bank Account Data
            </h5>
            <button type="button" class="btn-close position-absolute fs-4" aria-label="Close" style="right: 5px;top: 5px;" @click.prevent="showModal=false"></button>
            <div class="contain">
              <p class="card-text text-danger italic">Any changes done here will reflect only invoices generated after the change was applied.</p>
              <div class="row" v-for="r,index in Object.keys(rowData).filter(item=>!formHidden.includes(item))" :key="index">
                <float-select v-if="r=='bank_id'" label="Bank Name" :options="ddHolder.banks" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="ddHolder.banks.find((b)=>{return b.id==rowData[r]})"
                                                label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient" @change="fetchBranches(rowData[r])"/>
                
                <float-select v-if="r=='branch_id' " label="Branch Name" :options="ddHolder.branches" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="ddHolder['branches'].find((b)=>{return b.id==rowData[r]})"
                                                  label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient" />
                <float-select v-if="r=='type' " label="Type" :options="account_types" v-model="rowData[r]" :disabled="disabled.includes(r)" :ogDataSrc="rowData[r]" listMode="Array"
                                                  label-class="text-dark fw-bold" option-class="bg-primary-subtle bg-gradient" />

                <float-inp v-else-if="!['bank_id','branch_id'].includes(r)" type="text" :label="headers[r]" v-model="rowData[r]" class="col-12 px-1 mb-1" :disabled="disabled.includes(r)"
                label-class="text-dark fw-bold" input-class="bg-primary-subtle bg-gradient input" />
              </div>
            </div>
            <a href="#" v-if="rowData['id']===null || rowData['id']<1" class="btn btn-primary" @click.prevent="requestActionCaptcha({ title: 'Confirm Create', promptText: 'Solve the sum to create this bank account record.', confirmLabel: 'Create', action: () => postBranch('post') })" >Create Bank Account Details</a>
            <template v-else>
              <a href="#" class="btn btn-warning me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Duplicate', promptText: 'Solve the sum to duplicate this bank account record.', confirmLabel: 'Duplicate', action: () => duplicateCurrentRecord() })" >Duplicate</a>
              <a href="#" class="btn btn-success me-2" @click.prevent="requestActionCaptcha({ title: 'Confirm Update', promptText: 'Solve the sum to update this bank account record.', confirmLabel: 'Update', action: () => postBranch('put') })" >Update Bank Account Details</a>
              <button type="button" class="btn btn-outline-danger" @click.prevent="requestActionCaptcha({ title: 'Confirm Delete', promptText: 'Solve the sum to delete this bank account record.', confirmLabel: 'Delete', action: () => deleteCurrentRecord() })">
                <i class="bi bi-trash3 me-1"></i>
                Delete
              </button>
            </template>
          </div>
        </div>
        <cdTable :links="links" title="Bank Accounts" table-name="bank_account" :hidden="hidden" :headers="headers" :gen-form="false" v-else @popForm="e=>setRowData(e)" ></cdTable>
        <ActionCaptchaModal
          :show="showActionCaptcha"
          :title="captchaTitle"
          :prompt-text="captchaPromptText"
          :confirm-label="captchaConfirmLabel"
          @close="closeActionCaptcha"
          @confirmed="confirmActionCaptcha"
        />
        
      </TransitionGroup>
      
    </div>
  </template>
  <script>
  import floatInp from '@/parts/floatInp.vue';
  import { dropDownLinks } from '@/cd-links';
  import floatSelect from '@/parts/floatSelect.vue';
  import cdTable from '@/components/cddatatables/cdTable.vue';
  import ActionCaptchaModal from '@/components/mods/ActionCaptchaModal.vue';
  import { bankAccountLinks } from '@/cd-links';
  export default{
    components:{
      cdTable, floatInp, floatSelect, ActionCaptchaModal
    },
    data(){
      return {
        links: bankAccountLinks,
        headers:{
            id: "ID",            
            nickname: "Nickname",
            name: "Name on Account",
            type: "Type",
            description: "Description",
            account_no: "Account no.#",
            "bank_branch.bank.name": "Bank name",
            "bank_branch.name": "Branch name",
            'bank_branch.ifsc': "IFSC #",
            status: "Status",
            branch_id: "Branch",
            createdAt: "Created On",
            updatedAt: "Updated On",
          },
          hidden:[
            'creatorId',
            /* 'createdAt',
            'updatedAt', */
            'bank_id',
            'ent_id',
            'branch_id'
          ],
          formHidden:['creatorId','status','bank.name','ent_id','bank_branch.name','bank_branch.ifsc','bank_branch.id','bank_branch.bank.id','bank_branch.bank.name'],
          disabled:['id','createdAt','updatedAt'],
          showModal:false,
          rowData:{
            id:null,
            bank_id:null,
            branch_id:null,
            nickname:null,
            name:null,
            type:null,
            description:null,
            account_no:null,
            "bank.name":null,
            "branch.name":null,
            'branch.ifsc':null,
          } ,
          ddHolder:{
            banks:[],
            branches:[]
          },
          preFetch:false,
          loading: false,
          showActionCaptcha: false,
          captchaTitle: 'Confirm Action',
          captchaPromptText: 'Please solve this quick check to continue.',
          captchaConfirmLabel: 'Confirm',
          pendingAction: null,
          account_types:['Savings Account','Current Account','Salary Account','FCNR Account','Escrow Account','NRO Account','NRE Account','NRI Account']
      }
    },
    methods:{
      requestActionCaptcha({ title, promptText, confirmLabel, action }) {
        this.captchaTitle = title || 'Confirm Action';
        this.captchaPromptText = promptText || 'Please solve this quick check to continue.';
        this.captchaConfirmLabel = confirmLabel || 'Confirm';
        this.pendingAction = typeof action === 'function' ? action : null;
        this.showActionCaptcha = true;
      },
      closeActionCaptcha() {
        this.showActionCaptcha = false;
        this.pendingAction = null;
      },
      confirmActionCaptcha() {
        const action = this.pendingAction;
        this.showActionCaptcha = false;
        this.pendingAction = null;
        if (typeof action === 'function') action();
      },
      duplicateCurrentRecord(){
        const duplicated = JSON.parse(JSON.stringify(this.rowData || {}));
        duplicated.id = null;
        this.rowData = duplicated;
      },
      async deleteCurrentRecord(){
        if (!this.rowData?.id || this.rowData.id < 1) return;

        try {
          const resp = await this.$store.getters.getAxios(this.links.delItem, {
            method: 'delete',
            data: { id: this.rowData.id }
          });

          if (resp.data.isLoggedIn) {
            this.$store.commit('addAlert', {
              title: resp.data.title,
              message: resp.data.msg,
              type: resp.data.success ? 'info' : 'danger'
            });
            if (resp.data.success) this.showModal = false;
          } else {
            this.$store.dispatch('loggedOut');
          }
        } catch (err) {
          this.$store.commit('addAlert', {
            title: 'Error',
            message: err.response?.data?.msg || err.message || 'Error deleting bank account',
            type: 'danger'
          });
        }
      },
      async postBranch(mode){
        
        this.loading=true;
        this.rowData.status=true;
        typeof this.rowData.bank_id=='object'? this.rowData.bank_id = this.rowData.bank_id.id : null;
        typeof this.rowData.branch_id=='object'? this.rowData.branch_id = this.rowData.branch_id.id : null;
        this.rowData['ent_id']=this.$store.getters.getEntity;
        await this.$store.getters.getAxios(this.links[mode],{method:mode,data:this.rowData})
            .then(resp=>{

              if(resp.data.isLoggedIn){
                this.$store.commit('addAlert', {
                                      title: resp.data.title,
                                      message: resp.data.msg,
                                      type: resp.data.success? 'info' : 'danger'
                                  });
                resp.data.success? this.showModal=false : this.showModal=true;                            
                }
              else this.$store.dispatch('loggedOut');
            })
            // eslint-disable-next-line
            .catch(err=>{
                

            })
      },
      setRowData(e){
        console.log(e);
        if(e.rowData['id']!=null){
          this.fetchBranches({id:e.rowData['bank_id']});
        }
        this.rowData=e.rowData;
        this.rowData['branch_id']==undefined? this.rowData={branch_id:null,...this.rowData}:null;
        this.rowData['bank_id']==undefined? this.rowData={bank_id:null,...this.rowData}:null;
        this.showModal=true;
      },
      async getDropDownData(table,listName,filter) {
                    this.loading=true;
                    await this.$store.getters.getAxios.post(dropDownLinks[table],{ent_id:this.$store.getters.getEntity,filter:filter})
                        .then(resp=>{
                            if(!resp.data.isLoggedIn){
                                this.$store.dispatch('loggedOut');
                            }
                            else this.ddHolder[listName] =  resp.data.data;
                        })
                        // eslint-disable-next-line
                        .catch(err=>{
                            this.$store.commit('addAlert', {
                                title: "Error Getting DropDown Data for "+listName,
                                message: "Try after some time",
                                type: 'danger'
                            });
        
                        })
      },
      async fetchBranches(bank_id){
          await this.getDropDownData('branches','branches',{bank_id:bank_id.id});
      },
    },
    async mounted(){
        await this.getDropDownData('banks','banks',0);
        /* this.getDropDownData('branches','branches'); */
    }
  }
  </script>
  